@if (isReady) {
  <div class="ziro-admin-page-content">
    <div class="col-md-10 offset-md-1 ziro-report-content">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;reports.call_logs.description' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
      <ziro-call-logs-query-editor
        [config]="callLogsQueryEditorData"
        (callLogQueryResultUpdated)="handleQueryUpdate($event)"
      ></ziro-call-logs-query-editor>
      <ziro-datatable
        [isCondensed]="true"
        [columns]="columns"
        [rowDataSource]="data"
        [uniqueRowIdentifier]="null"
        [mainFilterPlaceholder]="'tkey;reports.call_logs.datatable.search' | translate"
        [dataAutomation]="tableDataAutomation"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.call_logs.datatable.columns.endCause'"
          [items]="endCauses"
          [matchFn]="doesRowCatchEndCauseFilter"
          [dataAutomation]="'call-logs-end-cause-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    </div>
  </div>
}
<ziro-bottom-nav data-automation="call-logs-bottom-nav"></ziro-bottom-nav>
<ziro-loading-block [hidden]="isReady"></ziro-loading-block>
